<template>
    <div class="container-fluid bg-white vh-100 p-0">
        <ClientLogo v-if="this.$route.name != 'behalf_application'" />
        <BreadCrumb label="Telephone List" />
        <div>
            <div class="d-flex justify-content-center align-items-center min-vh-50">
                <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
                    <!-- ID Type and ID Number in same row -->
                    <div class="form-group mt-3">
                        <div class="row">
                            <!-- ID Number -->
                            <div class="col-12 ps-2">
                                <label for="id_number" class="form-label fw-bold text-xxs">
                                    ID Number
                                    <span class="text-danger fw-bold">*</span>
                                </label>
                                <input id="id_number" type="text"
                                    class="form-control text-xxs rounded-small p-2 shadow-sm"
                                    v-model="id_number"
                                    :placeholder="'Enter SA ID Number'"
                                    :maxlength="13"
                                    @input="handle_id_input">
                            </div>
                        </div>
                        <div class="d-flex flex-column col-12 col-md-9 col-lg-8 mx-auto mt-1">
                            <small class="text-danger fw-bold text-xs d-none id-message">
                                Please fill in this field
                            </small>
                            <small class="text-danger fw-bold text-xs d-none invalid-message">
                                Please enter a valid ID number
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="submit"
                    class="btn bg-green btn-sm mt-1 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
                    @click="submit_form">
                    Continue
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
    import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
    import { API_BASE_URL } from "@/config";
    import { validateToken } from '@/utils/auth';
    import BreadCrumb from '@/components/BreadCrumb/BreadCrumb.vue';
    import ClientLogo from '@/components/ClientLogo/ClientLogo.vue';
import Swal from "sweetalert2";

    export default {
    name: 'TelephoneList',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    components: {
        BreadCrumb,
        ClientLogo
    },

    data: () => ({
        id_number: "",
        loading: false,
        error: ""
    }),

    computed: {
        workflow_id() {
            return this.$store.getters.get_workflow_id;
        }
    },

    methods: {
        handle_id_input(event) {
              // For National ID, only allow numbers
              this.id_number = event.target.value.replace(/[^0-9]/g, '');
        },
        validate_id(id_number) {
              // Also allow up to 13 digits for flexibility with other formats
              if (!id_number || id_number.length < 13) {
                  return false;
              }
              const id_regex = /^\d{13}$/;
              return id_regex.test(id_number);
        },
        show_error(selector) {
            $(selector).removeClass('d-none');
            setTimeout(() => {
                $(selector).addClass('d-none');
            }, 3000);
        },
        submit_form() {
            if (!this.id_number.trim()) {
                this.show_error('.id-message');
                return false;
            }
            if (!this.validate_id(this.id_number)) {
                this.show_error('.invalid-message');
                return false;
            }
            this.telephone_list();
        },

        telephone_list() {
            const TOKEN = localStorage.getItem('token');
            const TELEPHONES_API = `${API_BASE_URL}/verify_api/personnel_verification/telephone_list/`;

            this.loading = true;
            this.error = '';

            $.ajax({
                url: TELEPHONES_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    id_number: this.id_number,
                    workflow_id: this.workflow_id,
                    on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.completeService();
                },
                error: (xhr) => {
                    this.loading = false;
                    let response = xhr.responseJSON;
                    if (response && response.api_error_message) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.api_error_message,
                        });
                    } else if (response && response.message) {
                        Swal.fire({
                            icon: 'error',
                            title: response.message,
                            text: response.errors,
                        });
                    } else if (response && response.status === "SubjectNotFound") {
                        if (this.$route.name === 'behalf_application') {
                            Swal.fire({
                                icon: 'error',
                                title: response.message,
                                text: response.errors,
                            });
                        }
                    } else {
                        this.loading = false;
                        this.error = 'An error occurred while retrieving customer telephones. Please try again with a valid ID number or contact support if the issue persists.';
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: this.error,
                        });
                    }
                }
            });
        }
    },

    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
        this.get_customer_data();
    }
    };
</script>